export const schools = {
  link: {
    name: "Link School of Business",
    short: "LINK",
    country: "Brazil",
    size: 6,
  },
  mahindra: {
    name: "Mahindra University",
    short: "Mahindra",
    country: "India",
    size: 5,
  },
};

export const defaultLinkNames = [
  "Felipe Argolo",
  "Diogo Chiapeta",
  "Carol GCO",
  "Joao Mourao",
  "Hugo Mendes",
  "Lorenzo Vitti",
];

export const defaultMahindraNames = [
  "Aishwarya",
  "Aadhya",
  "Niyathi",
  "Saanvi",
  "Dhevarshini",
];
